module.exports = __webpack_public_path__ + "img/sprite.3b6c0920.svg";